import { useQuery } from 'react-query';

import { useSecurePortalFetcher } from '../../../../shared/hooks';
import {
  Count,
  PaginationParams,
  PaginationResponse,
  UseReactQueryPaginationOptions,
} from '../../../../shared/models';
import { DocumentSearchResult } from '../../documents/models';

export const usePendingApprovalQuery = (
  params: PaginationParams,
  options?: UseReactQueryPaginationOptions<DocumentSearchResult>
) => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(
    ['pending-approval-documents', params],
    async () => {
      const { pageIndex, pageSize, search, sortBy } = params;
      const { data } = await fetcher<PaginationResponse<DocumentSearchResult>>(
        '/v1/documents/pending',
        {
          query: {
            page: pageIndex,
            size: pageSize,
            query: search,
            sort: sortBy,
          },
        }
      ).json();

      return data;
    },
    options
  );
};

export const usePendingApprovalCountQuery = () => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(['pending-approval-count'], async () => {
    const { data } = await fetcher<Count>('/v1/documents/pending/count').json();

    return data;
  });
};
